//external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { func, number, string } from 'prop-types'

// components
import { MapTick } from './MapTick'
import { Link } from '@jelly/ui'

const Name = styled(Link)`
	color: ${({ theme }) => theme.colors.orange};
	display: block;
	font-size: 0.875rem;
	font-weight: 700;
	line-height: 1;
	margin-bottom: 0.5rem;
	text-decoration: none;

	&:hover {
		color: ${({ theme }) => theme.colors.teal};
		cursor: pointer;
	}
`

const CompanyInfoContainer = styled.div`
	background: #fff;
	border-color: ${({ theme }) => theme.colors.teal};
	border-radius: 0.5rem;
	border-style: solid;
	border-width: 0.25rem;
	padding: 0.5rem;
`

const MapInfoBoxWrap = styled.div`
	bottom: 4rem;
	left: -5rem;
	position: absolute;
	width: 10rem;
	z-index: 999;
`

const Phone = styled.div`
	margin-top: 0.5rem;
`

const Tick = styled.div`
	color: ${({ theme }) => theme.colors.teal};
	font-size: 1.25rem;
	margin-right: 0.5rem;
	margin-top: 0.25rem;
	position: absolute;
	right: 0;
	top: 0;

	&:hover {
		cursor: pointer;
	}
`

MapInfoBox.propTypes = {
	$onMouseAllow: func.isRequired, // from google-map-react
	address: string.isRequired,
	affiliateLink: string.isRequired,
	city: string.isRequired,
	country: string.isRequired,
	description: string.isRequired,
	id: string.isRequired,
	innerTickBorderColor: string.isRequired,
	lat: number.isRequired,
	lng: number.isRequired,
	logo: string.isRequired,
	logoUrl: string.isRequired,
	name: string.isRequired,
	onClick: func,
	phone: string.isRequired,
	state: string.isRequired,
	tickBorderColor: string.isRequired,
	zip: string.isRequired,
}

export function MapInfoBox({
	$onMouseAllow,
	address,
	affiliateLink,
	city,
	innerTickBorderColor,
	name,
	onClick,
	phone,
	state,
	tickBorderColor,
	zip,
}) {
	return (
		<MapInfoBoxWrap onMouseEnter={() => $onMouseAllow(false)} onMouseLeave={() => $onMouseAllow(true)}>
			<MapTick tickBorderColor={tickBorderColor} innerTickBorderColor={innerTickBorderColor}>
				<CompanyInfoContainer>
					<Name href={affiliateLink} target="_blank" rel="noopener noreferrer nofollow">
						{name}
					</Name>
					{address}
					<br />
					{city}, {state} {zip}
					<Phone>Phone: {phone}</Phone>
					<Tick
						onClick={() => {
							$onMouseAllow(true)
							onClick()
						}}
					>
						&times;
					</Tick>
				</CompanyInfoContainer>
			</MapTick>
		</MapInfoBoxWrap>
	)
}
